import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["external", "hrefLang"];
import styled, { css } from 'styled-components';
import englishSupersetStyles from '../utils/englishSupersetStyles';
import { CALYPSO_DARK, LINK_HOVER } from 'HubStyleTokens/colors';
import UILink from 'UIComponents/link/UILink';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
const wordBreakCss = css(["word-break:break-word;word-wrap:break-word;hyphens:none;code{font-weight:600;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transition:150ms;color:", ";text-decoration:none;cursor:pointer;&:hover{color:", ";text-decoration:underline;}}"], CALYPSO_DARK, LINK_HOVER);
export const StyledLink = styled(UILink).withConfig({
  displayName: "Link__StyledLink",
  componentId: "m2a5qw-0"
})(["", ""], wordBreakCss);
export const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "Link__StyledRouterLink",
  componentId: "m2a5qw-1"
})(["", ""], wordBreakCss);

/**
 * `html[lang]`-aware `UILink`. On non-English sites, adds the localized
 * equivalent of [EN] as a superscript to links that point to the `en-us`
 * instance. By default, `hrefLang="en-us"` is set to support crawlers and
 * to ensure the superset renders, as well as `external={true}` for a
 * consistent UX. These props can be overridden if needed.
 *
 * @example
 * ```mdx
 * <LinkWithEnglishSuperset href="https://developers.hubspot.com/en-only-path">Nachrichten</LinkWithEnglishSuperset>
 *
 * would render as
 *
 * Nachrichten [externalIcon] [EN]
 *
 * where [EN] is a localized (in this case, `de-de`) superscript
 * ```
 *
 * @see https://issues.hubspotcentral.com/browse/DGS-265
 */
export const LinkWithEnglishSuperset = styled(_ref => {
  let {
      external = true,
      hrefLang = 'en-us'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledLink, Object.assign({}, rest, {
    external: external
    // Prevents empty hreflang='' attribute from rendering to DOM
    ,
    hrefLang: hrefLang || undefined
  }));
}).withConfig({
  displayName: "Link__LinkWithEnglishSuperset",
  componentId: "m2a5qw-2"
})(["", ""], englishSupersetStyles);